var path = 'components/menu-link.tpl.html';
var html = " <md-button ui-sref-active-eq=tk-active ui-sref={{section.state}}> <md-icon ng-show=section.icon aria-label={{section.icon}} class=material-icons>{{section.icon}}</md-icon> <md-icon ng-show=section.svgIcon aria-label=\"{{section.name | translate}}\" md-svg-icon={{section.svgIcon}}></md-icon> {{section.name | translate}} </md-button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/menu-link.tpl.html
// module id = 1023
// module chunks = 1